<xemex-dialog-shell [title]="'login.terms.title' | translate">
  <div class="p-2 max-h-[60vh] overflow-y-auto">
    <p class="whitespace-pre-line text-sm text-gray-700">
      {{ 'login.terms.body' | translate }}
    </p>
  </div>

  <mat-dialog-actions actions>
    <xemex-outlined-button type="button" (click)="onClose()">
      {{ 'login.terms.close' | translate }}
    </xemex-outlined-button>
  </mat-dialog-actions>
</xemex-dialog-shell>
